<template>
  <van-notice-bar :scrollable="false">
    <van-swipe class="my-swipe" :autoplay="3000" style="height:4.1rem" :touchable="false" :show-indicators="false" :vertical="true">
      <van-swipe-item><img :src = "this.imgList[0]" alt="" ></van-swipe-item>
      <van-swipe-item><img :src = "this.imgList[1]" alt="" ></van-swipe-item>
      <van-swipe-item><img :src = "this.imgList[2]" alt="" ></van-swipe-item>
      <van-swipe-item><img :src = "this.imgList[3]" alt="" ></van-swipe-item>
    </van-swipe>
</van-notice-bar>


</template>

<script>
export default {
  data() {
    return {
      imgList:[
        require('@/assets/images/01.png'),
        require('@/assets/images/02.png'),
        require('@/assets/images/03.png'),
        require('@/assets/images/04.png')
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
  .van-notice-bar{
    height: 4.2rem;
    padding: 0;
    background-color: #fff;
     .my-swipe .van-swipe-item {
    // color: #fff;
    // font-size: 20px;
    // line-height: 150px;
    // text-align: center;
    // background-color: #39a9ed;
    img{
      width: 100%;
      height: 100%;
    }
  }
  }
  ::v-deep .van-notice-bar__content{
      left: 0;
      right: 0;
  }
  .notice-swipe {  
    height: 4.2rem;
    line-height: 0.8rem;
    width: 100%;
    img{
      display: inline-block;
      width: 100%;
      // height: 1.4rem;
      height: 100%;
    }
  }
</style>